import DropDown from '@/shared/components/DropDown/DropDown'
import { useTranslation } from 'react-i18next'
import Chip from '@/shared/components/Chip/Chip'
import { TranslationItemModel } from '@/shared/api/BaseAPI.model'
import styles from './AccordionTileItem.module.scss'
import accordionStyles from '../AccordionContent/AccordionContent.module.scss'
import OptionsTile from '../OptionsTile/OptionsTile'
import TranslationItem from '../TranslationItem/TranslationItem'

interface AccordionTileItemProps {
  title: string
  translations: TranslationItemModel[]
  relatedItemsNames?: string[]
  onEdit: () => void
  onDelete: () => void
  isExpanded: boolean
  onToggle: () => void
  /** This row's record is being fetched for the edit form. */
  isEditLoading?: boolean
}

function AccordionTileItem(props: AccordionTileItemProps) {
  const {
    title,
    translations,
    onEdit,
    onDelete,
    isExpanded,
    onToggle,
    relatedItemsNames,
    isEditLoading
  } = props
  const { t } = useTranslation()

  const toggleShowTranslations = onToggle

  return (
    <div className={accordionStyles.accordionTileItem}>
      <div className={styles.accordionTileItemWrapper}>
        <div className={styles.accordionTileItemHeader}>
          <div
            className={`body-bold-medium ${
              styles.accordionTileItemHeaderTitle
            } ${
              title === t('SIDEBAR_ACCORDION.MISSING_TRANSLATION')
                ? styles.missingTranslationTitle
                : ''
            }`}
          >
            {title}
          </div>
          <div className={styles.accordionTileItemHeaderIcon}>
            <OptionsTile
              onEdit={onEdit}
              onDelete={onDelete}
              isEditLoading={isEditLoading}
            />
          </div>
        </div>

        <div className={styles.accordionTileItemContent}>
          {translations.length > 0 && (
            <div className={styles.accordionTileItemDropdownContainer}>
              <DropDown
                text={t('SIDEBAR_ACCORDION.TILE_ITEM.SHOW_TRANSLATIONS')}
                fontSize="body-medium"
                toggledIcon="las la-angle-up"
                icon="las la-angle-down"
                onClick={toggleShowTranslations}
                isToggled={isExpanded}
                iconFontSize="icon-small"
              />
              {isExpanded && (
                <div className={styles.accordionTileItemContentTranslations}>
                  {translations.map(translation => (
                    <TranslationItem
                      key={translation.languageCode}
                      languageCode={translation.languageCode}
                      translationText={translation.name}
                      textAlignment="right"
                      fontSize="body-medium"
                      missingTranslation={
                        translation.name ===
                        t('SIDEBAR_ACCORDION.MISSING_TRANSLATION')
                      }
                    />
                  ))}
                </div>
              )}
            </div>
          )}
          {relatedItemsNames && relatedItemsNames.length > 0 && (
            <div className={styles.accordionTileItemRelatedItems}>
              <p
                className={`body-medium ${styles.accordionTileItemRelatedItemsTitle}`}
              >
                {t('SIDEBAR_ACCORDION.TILE_ITEM.RELATED_DISH_SIZES')}
              </p>
              <div className={styles.accordionChipContainer}>
                {relatedItemsNames.map(relatedItemName => (
                  <Chip label={relatedItemName} color="primary" />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AccordionTileItem
